import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MoldFormService } from '../../../../common/mold/components/form/form.service';
import { MoldRevisionItem } from '../../../../common/mold/models/item';
import { HosesDepartmentApiService } from '../../api/department.service';
import { MoldFormDialogTypes } from '../../../../common/mold/dialog/form/form.component';
import { MoldRevision } from '../../../../api/elite/types/mold-revision';
import { HosesMoldFormDialogComponent } from '../dialog/form/form.component';

@Injectable()
export class HosesMoldFormService extends MoldFormService<MoldRevisionItem> {
  protected readonly apiDepartmentRouter = inject(HosesDepartmentApiService);

  protected override createMoldDialog(
    molds: MoldRevisionItem['mold'][]
  ): Observable<any> {
    return this.dialog
      .open(HosesMoldFormDialogComponent, {
        data: {
          molds,
          type: 'create',
          selectItemCavities: true,
          department: this.departmentService.NAME,
        },
      })
      .afterClosed();
  }

  protected override createMoldObservable(
    res: MoldFormDialogTypes['return'],
    departmentId?: number
  ): Observable<MoldRevision | undefined> {
    if (!res) {
      return of(undefined);
    }
    const obs = (depId: number) =>
      this.apiRouter.createMold({
        ...res,
        moldData: {
          ...res.moldData,
          departmentId: depId,
        },
      });
    if (!departmentId) {
      return this.apiDepartmentRouter.getDepartment().pipe(
        switchMap((dep) => {
          departmentId = dep.id;
          return obs(dep.id);
        })
      );
    }
    return obs(departmentId);
  }
}
